// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import i18n from "./i18n";
import vueTap from "v-tap";
import vueTouch from "vue-touch";
// 👇 这里是新增的：引入 message 插件
import MessagePlugin from "./components/message/index";

// 配合expose-loader，全局导入jQuery
require("expose-loader?$!jquery");

Vue.config.productionTip = false;
Vue.use(vueTap);
Vue.use(vueTouch, { name: "v-touch" });

// 👇 注册 message 插件
Vue.use(MessagePlugin);

var GlobalVue = new Vue({
  el: "#app",
  i18n,
  router,
  template: "<App/>",
  components: { App },
  data: {
    language: i18n.locale,
  },
});



// WEBPACK FOOTER //
// ./src/main.js